import React, { useState, useEffect } from 'react';

/**
 * Retorna un componente diseñado para verse bien en dispositivos móviles, con la capacidad de reportar avance en la ejecución de un plan de campo
 * @param {object} data Datos de la ejecución del plan de campo de un bloque especifico
 * @param {number} index Indice de la lista al que pertenece este bloque
 * @param {function} reportarAvance Función para reportar el avance de la ejecución del plan de campo
 * @returns 
 */
const ContenedorEjecucionMovil = (p) => {
    const data = p.data ?? {};
    const index = p.index;
    const reportarAvance = p.reportarAvance ?? (() => { });
    const [diaSeleccion, setdiaSeleccion] = useState(data.dia_plan);
    const dias = ['lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado'];
    useEffect(() => { }, [p.data]);


    return (
        <div className='bw-600 round-s border border-4 shadow p-1 mt-2 mb-2'>
            <div className='row justify-content-evenly w-100 m-0 p-0'>
                <div className='w-100 text-center text-bold text-m'>{data.bloque}</div>
                <div className='w-70 border-bottom border-warning mb-2' />
                <div className='w-100' />
                <div className='bw-400 text-bold text-center border-bottom mb-3 pb-2'>
                    <span className='text-xs text-400 me-1'>Rancho:</span>{data.rancho}
                    <span className='text-bold opacity-50 ms-2 me-2'>|</span>
                    <span className='text-xs text-400 me-1'>valvula:</span>{data.valvula}
                    <span className='text-bold opacity-50 ms-2 me-2'>|</span>
                    <span className='text-xs text-400 me-1'>camas:</span>
                    {data.cama_inicio} a {data.cama_fin}
                </div>
                <div className='w-100' />
                <div className='w-100'></div>
                <div className='bw-150 mb-2 border-bottom text-center'>
                    <div className='w-100 text-xs text-bold text-center p-0 mb-0 text-s'>Planeado</div>
                    <div className='w-100 p-0 m-0'>{data.plantas_plan}</div>
                </div>
                <div className='bw-150 mb-2 border-bottom text-center'>
                    <div className='w-100 text-xs text-bold text-s text-center p-0 mb-0 text-s'>Ejecutado</div>
                    <div className='w-100 p-0 m-0'>{data.total_plantas_ejecutado}</div>
                </div>
                <div className='w-100  mt-3 mb-2' />
                <div className='w-100 text-center opacity-70 text-amber4'>Actualizar valores</div>
                <div className='w-50 mb-3'>
                    <div className='w-100 text-s text-center text-bold'>Dia</div>
                    <select className='form-control form-control-sm round-xxl border shadow-sm text-bold text-center'
                        onChange={(e) => setdiaSeleccion(+e.target.value)} value={diaSeleccion}>
                        {dias.map((d, i) => <option key={i + d + index} value={i + 1}>{d.toUpperCase()}</option>)}
                    </select>
                </div>
                <div className='w-50 mb-3'>
                    <div className='w-100 text-s text-center text-bold'>Ejecutado {dias[diaSeleccion - 1].toUpperCase()}</div>
                    <input type='number' step={1} className='form-control form-control-sm round-xxl border border-warning shadow-sm text-bold text-center'
                        value={data[`${dias[diaSeleccion - 1]}_ejecutado`]}
                        onChange={(e) => reportarAvance(diaSeleccion, e.target.value, index)} />
                </div>

            </div>
        </div>
    )
}

export default ContenedorEjecucionMovil;